<template lang="pug">
.new-article
  shForm(title="Nuevo Artículo")
</template>

<script>
import shForm from '@/components/pages/article/Form'

export default {
  name: 'NewArticle',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-article
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/article/New.vue